import { Provider, ModuleWithProviders } from '@angular/core';
import { DwRouterInfoService } from './router-info.service';
var DwRouterInfoModule = /** @class */ (function () {
    function DwRouterInfoModule() {
    }
    DwRouterInfoModule.forRoot = function (providers) {
        return {
            ngModule: DwRouterInfoModule,
            providers: [
                DwRouterInfoService
            ].concat(providers)
        };
    };
    return DwRouterInfoModule;
}());
export { DwRouterInfoModule };
